import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, computed } from '@angular/core';

import { EventOption, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { ParticipantImageService } from '@frontend/sports/participant-image/feature';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { RxFor } from '@rx-angular/template/for';
import { groupBy } from 'lodash-es';

import { BetBuilderOptionComponent } from './bet-builder-option.component';
import { GoalScorerGroupComponent } from './goal-scorer-group.component';
import { MarketHelpComponent } from './market-help/market-help.component';
import { BaseOptionGroupStatisticsService } from './player-statistics/base-option-group-statistics.service';
import { OptionGroupPlayerStatisticsService } from './player-statistics/option-group-player-statistics.service';

@Component({
    selector: 'ms-bet-builder-goalscorer-option-group',
    templateUrl: './bet-builder-goalscorer-option-group.component.html',
    providers: [ParticipantImageService, OptionGroupPlayerStatisticsService, BaseOptionGroupStatisticsService],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MarketHelpComponent, NgClass, RxFor, BetBuilderOptionComponent, IconCustomComponent],
})
export class BetBuilderPlayersOptionGroupComponent extends GoalScorerGroupComponent implements OnInit {
    @Input() showMarketAttribute = false;
    displayMultiSelectionText?: boolean = false;
    multiSelectionHelpText: string;
    readonly noOfColums = {
        double: 2,
        triple: 3,
        quadruple: 4,
        quintuple: 5,
        sextuple: 6,
        septuple: 7,
    };

    isSingleRowOfOptions = computed(
        () => this.optionGroup.options.length === this.noOfColums[this.scoreOptionsClass() as keyof typeof this.noOfColums],
    );

    override ngOnInit(): void {
        if (this.sitecore.betBuilderEntainUI.messages) {
            this.multiSelectionHelpText = this.sitecore.betBuilderEntainUI.messages.MultiSelectionInfo;
        }

        this.displayMultiSelectionText = this.optionGroup.isMultipleSelection;
    }

    override groupOptions(optionGroup: EventOptionGroup): Record<string, [...EventOption[]]> {
        return groupBy(optionGroup.options, (option) => option.optionAttribute);
    }

    override getGroupingKey(options: [...EventOption[]], key: string): string {
        return options[0]?.overridenName || key;
    }
}
